import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { RePermitStatus } from '@work4all/models/lib/Enums/RePermitStatus.enum';

import { FixedDataPicker } from '../fixed-data-picker/FixedDataPicker';
import { IPickerProps } from '../types';

type Props<TMultiple extends boolean> = IPickerProps<
  { id: string; name: string },
  TMultiple
>;

export function PermitStatusPicker<TMultiple extends boolean>(
  props: Props<TMultiple>
) {
  const { t } = useTranslation();
  const data = useMemo(() => {
    return Object.keys(RePermitStatus)
      .map((key) => {
        const id = RePermitStatus[key];

        return {
          id,
          name: t(`PERMIT_STATUSES.${id}`),
        };
      })
      .sort((a, b) => a.name.localeCompare(b.name));
  }, [t]);

  return <FixedDataPicker dataSet={data} {...props} />;
}
